/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./raiseHandList.vue?vue&type=template&id=062c8d7b&scoped=true&"
import script from "./raiseHandList.vue?vue&type=script&lang=js&"
export * from "./raiseHandList.vue?vue&type=script&lang=js&"
import style0 from "./raiseHandList.vue?vue&type=style&index=0&id=062c8d7b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c8d7b",
  null
  
)

export default component.exports